export default "__VITE_ASSET__C8E1Jqwk__"